import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircle, Tag, ShoppingBag, Boxes, Star, Users, ChevronRight } from 'lucide-react';

const CommandQuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    { title: 'Add Product', icon: PlusCircle, path: '/admin/panels' },
    { title: 'Create Promo', icon: Tag, path: '/admin/promotions' },
    { title: 'View Orders', icon: ShoppingBag, path: '/admin/orders' },
    { title: 'Check Inventory', icon: Boxes, path: '/admin/inventory' },
    { title: 'Store Reviews', icon: Star, path: '/admin/reviews' },
    { title: 'Customers', icon: Users, path: '/admin/customers' },
  ];

  return (
    <div className="feed-card-box">
      <h3 style={{ fontSize: '12px', fontWeight: 800, color: '#dc2626', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '8px' }}>
        QUICK STORE ACTIONS
      </h3>

      <div className="quick-actions-2x3-grid">
        {actions.map((act, index) => {
          const IconComp = act.icon;
          return (
            <button key={index} className="action-tile-btn" onClick={() => navigate(act.path)}>
              <IconComp size={16} color="#dc2626" />
              <span>{act.title}</span>
            </button>
          );
        })}
      </div>

      <button className="btn-solid-red-full" onClick={() => navigate('/admin/settings')}>
        <span>⚙ Store Settings</span>
        <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default CommandQuickActions;
